import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const [loading, setLoading] = useState(true);
  const [userProfile, setUserProfile] = useState([]);
  const [token, setToken] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isEditor, setIsEditor] = useState(false)
  const [isViewer, setIsViewer] = useState(false)
  const [isSuperUser, setIsSuperUser] = useState(false);

  useEffect(() => {
    const initializeProfile = () => {
      const userProfileSession = getLoggedinUser();

      if (!userProfileSession) {
        setLoading(false);
        return;
      }
      const accessToken = userProfileSession?.access;

      setUserProfile(userProfileSession);
      setToken(accessToken);
      setLoading(false);
      setIsAdmin(userProfileSession?.user?.groups?.includes("Admin"))
      setIsEditor(userProfileSession?.user?.groups?.includes("Editor"))
      setIsViewer(userProfileSession?.user?.groups?.includes("Viewer"))
      setIsSuperUser(userProfileSession?.user?.is_superuser)
    };

    initializeProfile();

    // Optional: Add event listener for storage changes
    const handleStorageChange = () => {
      initializeProfile();
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Optional: Add method to update profile
  const updateProfile = (newProfile) => {
    setUserProfile(newProfile);
    setToken(newProfile?.access);
  };

  return {
    userProfile,
    isAdmin,
    isViewer,
    isEditor,
    isSuperUser,
    loading,
    token,
    updateProfile // Optional: expose method to update profile
  };
};

export { useProfile };
